import React, { useState, useRef, useEffect } from "react";
import NormalLayout from "../../components/layout/NormalLayout";
import { genExcelDownloadFunc } from "../../utils/GenExcelDownloadFile";
import axios from "axios";
import {
  Table,
  Button,
  Row,
  Col,
  Tooltip,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Progress,
} from "reactstrap";
import Moment from "react-moment";
import { Cookies } from "react-cookie";
import AdminSearchForm from "../../components/search/AdminSearchForm";
import { excelUpdate } from "../../utils/AdminExcelUpdate";
import readXlsxFile from "read-excel-file";
import { useNavigate } from "react-router-dom";

const cookies = new Cookies();

// 도매업체들의 주문서 확인페이지
// 업체별 주문서 검토
function AdminProcessing() {
  const [data, setData] = useState(null);
  const [companyObj, setCompanyObj] = useState(null);
  const [targetData, setTargetData] = useState(null);
  const [ordersObj, setOrdersObj] = useState({});
  const [wholesalerArr, setWholesalerArr] = useState([]);
  const [filteredOrders, setFilteredOrders] = useState();
  const [currentWholesaler, setCurrentWholesaler] = useState();
  const [tooltipOpen, setTooltipOpen] = useState({});
  const [confirmModal, setConfirmModal] = useState(false);
  const [saveProgress, setSaveProgress] = useState(null); // { current, total }
  const [finalStock, setFinalStock] = useState(null);

  const fileInputRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    excelListData();
  }, []);

  useEffect(() => {
    if (!targetData) {
      setFinalStock(null);
      return;
    }
    const stockMap = {};
    targetData.ordersArr.forEach((orderNo) => {
      const order = targetData.ordersObj[orderNo];
      if (order.hawb === "취소") return;
      order.items.forEach((item) => {
        if (!item.productCode) return;
        const code = item.productCode.toUpperCase();
        if (code === "BRING" || code.startsWith("R") || code.startsWith("V"))
          return;
        if (!stockMap[code]) {
          stockMap[code] = { productName: item.productName, qty: 0 };
        }
        stockMap[code].qty += Number(item.qauntity) || 0;
      });
    });
    setFinalStock(stockMap);
  }, [targetData]);

  // 모달창 제어
  const confirmToggle = () => setConfirmModal(!confirmModal);

  const excelListData = async () => {
    try {
      const resList = await axios.get(
        `${process.env.REACT_APP_WHOLESALE_API_URL}/admin/order?status=PROCESSING`,
        {
          headers: {
            Authorization: cookies.get("info").token,
          },
        },
      );

      if (resList.data.msg !== "no data") {
        setData(resList.data.data.list);
        setFilteredOrders(resList.data.data.list);
        genSummary(resList.data.data.list);
      }

      // 도매업체 정보 가져오기
      const companies = await axios.get(
        `${process.env.REACT_APP_WHOLESALE_API_URL}/admin/company`,
        {
          headers: {
            Authorization: cookies.get("info").token,
          },
        },
      );

      let tempCompanyObj = {};
      companies.data.companies &&
        companies.data.companies.length > 0 &&
        companies.data.companies.map((c) => {
          tempCompanyObj[c.wholesaler] = {
            manager: c.manager_name,
            email: c.manager_email,
            grade: c.purchase_grade,
          };
        });

      setCompanyObj(tempCompanyObj);
    } catch (error) {
      console.error("데이터를 불러오는데 실패했습니다", error);
    }
  };

  // 업체별 주문건 요약
  const genSummary = (orders) => {
    let tempObj = {};

    orders.map((order) => {
      if (tempObj.hasOwnProperty(order.wholesaler)) {
        tempObj[order.wholesaler].push(order);
      } else {
        tempObj[order.wholesaler] = [order];
      }
    });

    const sortedKeys = Object.keys(tempObj).sort();

    // 도매업체 리스트 및 업체별 주문건 설정
    setWholesalerArr(sortedKeys);
    setOrdersObj(tempObj);
  };

  // 주문건별 총 상품금액 계산함수
  const genAmount = (items) => {
    let amount = 0.0;

    items.map((item) => {
      let price = convertPriceFormat(
        item.productCode,
        item.unitPrice,
        item.qauntity,
      ).replace("$", "");
      if (!isNaN(price)) {
        amount += parseFloat(price);
      }
    });
    return amount.toFixed(2);
  };

  const convertPriceFormat = (productCode, unitPrice, qauntity) => {
    let resValue = null;

    if (!productCode) {
      return "미정";
    }

    let pcode = productCode.toUpperCase();

    // 예외처리 코드 : BRING, CHEMIST, MART, PROMO, SPECIAL, 공백
    if (pcode === "BRING" || pcode === "PROMO") {
      resValue = "$0";
    } else if (
      pcode === "CHEMIST" ||
      pcode === "MART" ||
      pcode === "SPECIAL" ||
      pcode === ""
    ) {
      resValue = "미정";
    } else {
      resValue =
        "$" +
        parseFloat(unitPrice * qauntity)
          .toFixed(2)
          .toString();
    }
    return resValue;
  };

  const selectedOrders = (wholesaler) => {
    setFilteredOrders(ordersObj[wholesaler]);
    setCurrentWholesaler(wholesaler);
  };

  const getExcelDownload = () => {
    let tempOrders = data;
    tempOrders.sort((a, b) => {
      if (a.wholesaler < b.wholesaler) {
        return -1;
      }
      if (a.wholesaler > b.wholesaler) {
        return 1;
      }
      return 0;
    });

    // 주문건 상태변경 : 주문등록  완료 > 주문처리중
    genExcelDownloadFunc(tempOrders, companyObj);
  };

  // const deleteOrder = async (orderIndex) => {
  //   try {
  //     const resList = await axios.delete(
  //       `${process.env.REACT_APP_WHOLESALE_API_URL}/admin/order?orderindex=${orderIndex}`,
  //       {
  //         headers: {
  //           Authorization: cookies.get("info").token,
  //         },
  //       }
  //     );
  //     if (resList.data.result === "success") {
  //       excelListData();
  //     } else {
  //       console.error("주문건을 삭제하는데 실패했습니다");
  //     }
  //   } catch (error) {
  //     console.error("주문건을 삭제하는데 실패했습니다", error);
  //   }
  // };

  const cancelOrder = async (orderIndex) => {
    let ordersNoArr = [];
    ordersNoArr.push(orderIndex);

    try {
      const resList = await axios.put(
        `${process.env.REACT_APP_WHOLESALE_API_URL}/admin/order/status`,
        {
          ordersNoArr,
          after: "CANCEL",
          before: "PROCESSING",
        },
        {
          headers: {
            Authorization: cookies.get("info").token,
          },
        },
      );
      if (resList.data.result === "success") {
        excelListData();
      } else {
        console.error("주문건을 삭제하는데 실패했습니다");
      }
    } catch (error) {
      console.error("주문건을 삭제하는데 실패했습니다", error);
    }
  };

  // const handleDelete = (orderIndex, name) => {
  //   // 사용자에게 확인을 요청하는 알림 표시
  //   const isConfirmed = window.confirm(`${name}님 주문을 삭제하시겠습니까?`);

  //   if (isConfirmed) {
  //     deleteOrder(orderIndex);
  //   } else {
  //     // 사용자가 '취소'를 클릭했을 때 수행할 작업
  //     console.log("사용자가 삭제를 취소했습니다.");
  //   }
  // };

  const handleCancel = (orderIndex, name) => {
    // 사용자에게 확인을 요청하는 알림 표시
    const isConfirmed = window.confirm(`${name}님 주문을 취소하시겠습니까?`);

    if (isConfirmed) {
      cancelOrder(orderIndex);
    } else {
      // 사용자가 '취소'를 클릭했을 때 수행할 작업
      console.log("사용자가 삭제를 취소했습니다.");
    }
  };

  const toggleTooltip = (receiver) => {
    setTooltipOpen({
      ...tooltipOpen,
      [receiver]: !tooltipOpen[receiver],
    });
  };

  // 주문정보 업데이트를 위한 엑셀파일 분석
  const readUploadFile = async (e) => {
    const rows = await readXlsxFile(e.target.files[0]).then(
      (resRows) => resRows,
    );
    fileInputRef.current.value = "";

    let result = excelUpdate(rows);

    if (result.ordersArr.length === 0) {
      alert("발송완료 변경대상 주문건이 없습니다.");
      return;
    }

    // DB에서 PROCESSING 상태인 주문번호만 허용
    const processingSet = new Set((data || []).map((o) => o.order_no));

    const filteredOrdersArr = result.ordersArr.filter((no) =>
      processingSet.has(no),
    );

    if (filteredOrdersArr.length === 0) {
      alert("PROCESSING 상태의 업데이트 대상 주문건이 없습니다.");
      return;
    }

    const filteredOrdersObj = {};
    filteredOrdersArr.forEach((no) => {
      filteredOrdersObj[no] = result.ordersObj[no];
    });

    const filteredWholesaleObj = {};
    Object.keys(result.wholesaleObj).forEach((ws) => {
      const filtered = result.wholesaleObj[ws].filter((no) =>
        processingSet.has(no),
      );
      if (filtered.length > 0) filteredWholesaleObj[ws] = filtered;
    });

    result.ordersArr = filteredOrdersArr;
    result.ordersObj = filteredOrdersObj;
    result.wholesaleObj = filteredWholesaleObj;
    result.targetWholesaler = Object.keys(filteredWholesaleObj);

    console.log("결과ㅏ", result);

    setTargetData(result);
    confirmToggle();
  };

  const handleSave = async () => {
    // 발송완료 변경 대상건 처리
    const BATCH_SIZE = 10;

    let wholesaleInfo = {};
    targetData.targetWholesaler.map((w) => {
      wholesaleInfo[w] = companyObj[w];
    });

    // orderNo -> wholesaler 역매핑 생성
    const orderToWholesaler = {};
    Object.keys(targetData.wholesaleObj).forEach((wholesaler) => {
      targetData.wholesaleObj[wholesaler].forEach((orderNo) => {
        orderToWholesaler[orderNo] = wholesaler;
      });
    });

    const allOrdersArr = targetData.ordersArr;

    const totalChunks = Math.ceil(allOrdersArr.length / BATCH_SIZE);
    setSaveProgress({ current: 0, total: totalChunks });

    try {
      for (let i = 0; i < allOrdersArr.length; i += BATCH_SIZE) {
        const chunkOrdersArr = allOrdersArr.slice(i, i + BATCH_SIZE);
        const isLastChunk = i + BATCH_SIZE >= allOrdersArr.length;
        const chunkIndex = Math.floor(i / BATCH_SIZE) + 1;
        setSaveProgress({ current: chunkIndex, total: totalChunks });

        // 이번 청크의 ordersObj 구성
        const chunkOrdersObj = {};
        chunkOrdersArr.forEach((orderNo) => {
          chunkOrdersObj[orderNo] = targetData.ordersObj[orderNo];
        });

        // 이번 청크의 wholesaleObj 구성
        const chunkWholesaleObj = {};
        const chunkWholesaleArr = [];
        chunkOrdersArr.forEach((orderNo) => {
          const wholesaler = orderToWholesaler[orderNo];
          if (wholesaler) {
            if (!chunkWholesaleObj[wholesaler]) {
              chunkWholesaleObj[wholesaler] = [];
              chunkWholesaleArr.push(wholesaler);
            }
            chunkWholesaleObj[wholesaler].push(orderNo);
          }
        });

        const resList = await axios.put(
          `${process.env.REACT_APP_WHOLESALE_API_URL}/admin/order/update`,
          {
            ordersArr: chunkOrdersArr,
            ordersObj: chunkOrdersObj,
            wholesaleArr: chunkWholesaleArr,
            wholesaleObj: chunkWholesaleObj,
            finalStock: finalStock,
            // 마지막 청크에서만 wholesaleInfo 전송 (이메일 알림)
            wholesaleInfo: isLastChunk ? wholesaleInfo : {},
          },
          {
            headers: {
              Authorization: cookies.get("info").token,
            },
          },
        );

        if (resList.data.result !== "success") {
          console.error("주문건 상태를 업데이트하는데 실패했습니다");
          alert(
            `${i + 1}~${Math.min(i + BATCH_SIZE, allOrdersArr.length)}번째 주문 업데이트에 실패했습니다.`,
          );
          return;
        }
      }

      setSaveProgress(null);
      confirmToggle();
      navigate("/admin/done");
    } catch (error) {
      console.error("주문건 상태를 업데이트하는데 실패했습니다", error);
      alert("주문 업데이트 중 오류가 발생했습니다. 다시 시도해주세요.");
      setSaveProgress(null);
    }
  };

  return (
    <NormalLayout>
      <Modal isOpen={confirmModal} toggle={confirmToggle} size="lg">
        <ModalHeader toggle={confirmToggle}>
          주문 업데이트 확인{" "}
          {targetData && <>(총 {targetData.ordersArr.length}건)</>}
        </ModalHeader>
        <ModalBody>
          {targetData && (
            <>
              {targetData.targetWholesaler.map((w, idx) => (
                <div key={idx} className="mb-3">
                  <h6 className="fw-bold mb-1">
                    {w} ({targetData.wholesaleObj[w].length}건)
                  </h6>
                  <table
                    className="table table-sm table-bordered mb-0"
                    style={{ tableLayout: "fixed" }}
                  >
                    <colgroup>
                      <col style={{ width: "20%" }} />
                      <col style={{ width: "20%" }} />
                      <col style={{ width: "20%" }} />
                      <col style={{ width: "20%" }} />
                      <col style={{ width: "20%" }} />
                    </colgroup>
                    <thead className="table-light">
                      <tr>
                        <th>#</th>
                        <th>고객명</th>
                        <th>HAWB</th>
                        <th>무게</th>
                        <th>배송비</th>
                      </tr>
                    </thead>
                    <tbody>
                      {targetData.wholesaleObj[w].map((o, idx2) => {
                        const isCancelled =
                          targetData.ordersObj[o].hawb === "취소";
                        return (
                          <tr
                            key={idx2}
                            style={
                              isCancelled ? { backgroundColor: "#f8d7da" } : {}
                            }
                          >
                            <td>{idx2 + 1}</td>
                            <td>{targetData.ordersObj[o].customerName}</td>
                            <td>{targetData.ordersObj[o].hawb}</td>
                            <td>{targetData.ordersObj[o].weight}kg</td>
                            <td>
                              $
                              {parseFloat(
                                targetData.ordersObj[o].deliveryFee,
                              ).toFixed(2)}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              ))}
              {(() => {
                const stockMap = {};
                targetData.ordersArr.forEach((orderNo) => {
                  const order = targetData.ordersObj[orderNo];
                  if (order.hawb === "취소") return;
                  order.items.forEach((item) => {
                    if (!item.productCode) return;
                    const code = item.productCode.toUpperCase();
                    if (
                      code === "BRING" ||
                      code.startsWith("R") ||
                      code.startsWith("V")
                    )
                      return;
                    if (!stockMap[code]) {
                      stockMap[code] = {
                        productName: item.productName,
                        qty: 0,
                      };
                    }
                    stockMap[code].qty += Number(item.qauntity) || 0;
                  });
                });

                const entries = Object.entries(stockMap);
                if (entries.length === 0) return null;
                return (
                  <div className="mt-2">
                    <h6 className="fw-bold mb-1">출고 대상 제품</h6>
                    <table
                      className="table table-sm table-bordered mb-0"
                      style={{ tableLayout: "fixed" }}
                    >
                      <colgroup>
                        <col style={{ width: "5%" }} />
                        <col style={{ width: "15%" }} />
                        <col style={{ width: "65%" }} />
                        <col style={{ width: "15%" }} />
                      </colgroup>
                      <thead className="table-warning">
                        <tr>
                          <th>#</th>
                          <th>상품코드</th>
                          <th>상품명</th>
                          <th>수량</th>
                        </tr>
                      </thead>
                      <tbody>
                        {entries.map(([code, { productName, qty }], i) => (
                          <tr key={code}>
                            <td>{i + 1}</td>
                            <td>{code}</td>
                            <td>{productName}</td>
                            <td>{qty}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                );
              })()}
            </>
          )}
        </ModalBody>
        <ModalFooter className="flex-column align-items-stretch gap-2">
          {saveProgress && (
            <div className="w-100">
              <div className="d-flex justify-content-between mb-1 small">
                <span>업데이트 중...</span>
                <span>
                  {saveProgress.current} / {saveProgress.total} 배치
                </span>
              </div>
              <Progress
                value={(saveProgress.current / saveProgress.total) * 100}
                animated
              />
            </div>
          )}
          <div className="d-flex gap-2 justify-content-end w-100">
            <Button
              color="primary"
              onClick={() => handleSave()}
              disabled={!!saveProgress}
            >
              저장
            </Button>
            <Button
              color="secondary"
              onClick={confirmToggle}
              disabled={!!saveProgress}
            >
              취소
            </Button>
          </div>
        </ModalFooter>
      </Modal>
      <div>
        <h3>
          주문 처리 중
          {data && data.length !== 0 ? <>({data.length}건)</> : <></>}
        </h3>
      </div>
      <div className="p-3"></div>
      {filteredOrders ? (
        <>
          <div className="border p-3">
            <div className="mb-3">
              <div className="p-3  mb-3 border  bg-light">
                <h4>업체별 주문현황</h4>
                <Row className="mt-3">
                  {wholesalerArr &&
                    wholesalerArr.length > 0 &&
                    wholesalerArr.map((wholesaler, index) => {
                      return (
                        <Col
                          key={index}
                          md={2}
                          className="border p-2 rounded m-2 text-center"
                          style={{
                            backgroundColor:
                              currentWholesaler === wholesaler ? "orange" : "",
                          }}
                        >
                          <div onClick={() => selectedOrders(wholesaler)}>
                            <h6 className="bold_600">{wholesaler}</h6>
                            {ordersObj && ordersObj[wholesaler].length}건
                          </div>
                        </Col>
                      );
                    })}
                </Row>
              </div>
              <div className="mb-3">
                <Row>
                  <Col md={"6"} className="mt-1">
                    <div className="border p-3" style={{ height: "170px" }}>
                      <h4 className="bold-600">주문정보 다운로드</h4>
                      <div className="mt-3 text-center p-3">
                        {data && data.length > 0 && (
                          <Button
                            size="lg"
                            color="warning"
                            onClick={() => getExcelDownload()}
                          >
                            엑셀 다운로드
                          </Button>
                        )}
                      </div>
                    </div>
                  </Col>
                  <Col md={"6"} className="mt-1">
                    <div
                      className="border p-3"
                      style={{ height: "170px", cursor: "pointer" }}
                      onDragOver={(e) => e.preventDefault()}
                      onDrop={(e) => {
                        e.preventDefault();
                        const file = e.dataTransfer.files[0];
                        if (file) readUploadFile({ target: { files: [file] } });
                      }}
                    >
                      <h4 className="bold-600">주문정보 업데이트</h4>
                      <div className="mt-4 text-center">
                        <form className="p-3">
                          <label htmlFor="upload">
                            엑셀파일 업로드 또는 드래그
                          </label>
                          <input
                            type="file"
                            name="upload"
                            id="upload"
                            ref={fileInputRef}
                            onChange={readUploadFile}
                          />
                        </form>
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
              <AdminSearchForm
                target="PROCESSING"
                setFilteredOrders={setFilteredOrders}
                token={cookies.get("info").token}
              />
            </div>
            <Table hover striped bordered>
              <thead>
                <tr className="table-primary">
                  <th className="text-center p-2 border">등록일</th>
                  <th className="text-center p-2 border">업체명</th>
                  <th className="text-center p-2 border">구분</th>
                  <th className="text-center p-2 border">요청메모</th>
                  <th className="text-center p-2 border">이름</th>
                  <th className="text-center p-2 border">통관부호</th>
                  <th className="text-center p-2 border">배송메모</th>
                  <th className="text-center p-2 border">주문상품</th>
                  <th className="text-center p-2 border">총액</th>
                  <th className="text-center p-2 border">기능</th>
                </tr>
              </thead>
              <tbody>
                {filteredOrders.map((o, idx) => {
                  return (
                    <tr key={idx}>
                      <td className="text-center">
                        <Moment format="YYYY/MM/DD">{o.created_at}</Moment>
                      </td>
                      <td className="text-center">{o.wholesaler}</td>
                      <td className="text-center">
                        {(companyObj && companyObj[o.wholesaler]?.grade) ||
                          "기타"}
                      </td>

                      <td className="text-center cell">{o.shipper_memo}</td>
                      <td className="text-center">
                        <span id={`Tooltip-${o.order_index}`}>
                          {" "}
                          {o.customer_name}
                        </span>
                        <Tooltip
                          placement="top"
                          isOpen={tooltipOpen[o.order_index]}
                          target={`Tooltip-${o.order_index}`}
                          toggle={() => toggleTooltip(o.order_index)}
                        >
                          <div className="text-start">
                            <li>T : {o.customer_tel}</li>
                            <li>M : {o.customer_mobile}</li>
                            <li>
                              A : {o.address}, #{o.zip}
                            </li>
                          </div>
                        </Tooltip>
                      </td>
                      {/* <td className="text-center">{o.customer_tel}</td>
                      <td className="text-center">{o.customer_mobile}</td> */}
                      <td className="text-center">{o.pcc}</td>

                      {/* <td className="text-center">{o.zip}</td>
                      <td>{o.address}</td> */}

                      <td>{o.delivery_memo}</td>
                      <td style={{ padding: "0px" }}>
                        <Table
                          bordered
                          style={{ margin: "0px", width: "100%" }}
                        >
                          <tbody>
                            {o.order_product.map((i, index) => {
                              return (
                                <tr key={index}>
                                  <td
                                    className="text-center"
                                    style={{ width: "70px" }}
                                  >
                                    {i.productCode}
                                  </td>

                                  <td className="cell">{i.productName}</td>
                                  <td
                                    style={{ width: "60px" }}
                                    className="text-center"
                                  >
                                    {i.qauntity}개
                                  </td>
                                  <td
                                    style={{ width: "70px" }}
                                    className="text-center"
                                  >
                                    {convertPriceFormat(
                                      i.productCode,
                                      i.unitPrice,
                                      i.qauntity,
                                    )}
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </Table>
                      </td>
                      {/* <td className="text-center">{o.weight}</td>
                      <td className="text-center">{o.delivery_fee}</td> */}
                      <td className="text-center">
                        ${genAmount(o.order_product)}
                      </td>
                      {/* <td className="text-center">{o.hawb}</td> */}

                      <td className="text-center" style={{ width: "70px" }}>
                        {/* <Button
                          color="primary"
                          style={{ fontSize: "12px" }}
                          onClick={() => alert("개발중")}
                        >
                          수정
                        </Button>{" "} */}
                        {/* <Button
                          color="danger"
                          style={{ fontSize: "12px" }}
                          onClick={() =>
                            handleDelete(o.order_index, o.customer_name)
                          }
                        >
                          삭제
                        </Button> */}
                        <Button
                          color="danger"
                          style={{ fontSize: "12px" }}
                          onClick={() =>
                            handleCancel(o.order_index, o.customer_name)
                          }
                        >
                          취소
                        </Button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          </div>
        </>
      ) : (
        <>주문 데이터 없음</>
      )}
    </NormalLayout>
  );
}

export default AdminProcessing;
